import React from 'react';
import PropTypes from 'prop-types';

const ChevronDown = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.99999 6.99999C2.88358 7.1161 2.79122 7.25404 2.7282 7.4059C2.66519 7.55777 2.63275 7.72057 2.63275 7.88499C2.63275 8.04941 2.66519 8.21221 2.7282 8.36407C2.79122 8.51593 2.88358 8.65387 2.99999 8.76999L11.3 17.08C11.4869 17.2632 11.7382 17.3658 12 17.3658C12.2617 17.3658 12.5131 17.2632 12.7 17.08L21 8.76999C21.1439 8.66176 21.263 8.52392 21.3492 8.36579C21.4353 8.20765 21.4866 8.03287 21.4995 7.85324C21.5124 7.67361 21.4867 7.49331 21.424 7.32447C21.3613 7.15563 21.2632 7.00219 21.1362 6.87448C21.0092 6.74678 20.8564 6.64778 20.6879 6.58416C20.5194 6.52053 20.3392 6.49377 20.1595 6.50566C19.9798 6.51755 19.8048 6.56783 19.6462 6.6531C19.4875 6.73837 19.349 6.85666 19.24 6.99999L12 14.24L4.73999 6.99999C4.50678 6.77394 4.19476 6.64754 3.86999 6.64754C3.54521 6.64754 3.23319 6.77394 2.99999 6.99999Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

ChevronDown.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default ChevronDown;
